import React, { useEffect, useRef, useState } from "react";
import UnlimitInput from "./ui-kit/unlimit-input";
import { useForm } from "react-hook-form";
import UnlimitSubmitButton from "./ui-kit/unlimit-submit-button";
import httpService from "../services/http/settings/faq-type.service";
import notificationService from "../services/toaster.service";
import { store } from "../core/redux/store";
import { hydrateErrors } from "../utils/error.utils";
import UnlimitToggle from "./ui-kit/unlimit-toggle";
import { useTranslation } from "react-i18next";
import UnlimitFileUpload from "./ui-kit/unlimit-fileupload";

const FaqTypeDetail = ({ onHide, faqType }) => {
  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    reset,
  } = useForm();
  const { errors } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [existingImageUrl, setExistingImageUrl] = useState("");
  const modalRef = useRef();
  const { auth, locations } = store.getState();
  const { t } = useTranslation();
  const onSubmitForm = async (data) => {
    const user = auth.user;
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("status", data.status ? 1 : 0);
      if (data.icon[0]) {
        formData.append("icon", data.icon[0]);
      }
      if (faqType) {
        formData.append("id", faqType.id);
        await updateFaqType(formData);
      } else {
        await createFaqType(formData);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const createFaqType = async (formData) => {
    try {
      const response = await httpService.createFaqType(formData);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("faqType.faqTypeCreateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const updateFaqType = async (formData) => {
    try {
      const response = await httpService.updateFaqType(formData);
      if (response && response.status === 200) {
        notificationService.successMessage(
          t("faqType.faqTypeUpdateSuccess")
        );
        onHide();
        reset();
        modalHide();
      }
    } catch (error) {
      if (error.validation_error.errors) {
        hydrateErrors(error.validation_error.errors, setError);
      }
    }
  };
  const modalHide = () => {
    const cancelButton = document.querySelector(".btn-cancel");
    if (cancelButton) {
      cancelButton.click();
    }
  };
  useEffect(() => {
    if (faqType) {
      setValue("name", faqType.name);
      setValue("status", faqType.status == "active" ? true : false);
      setExistingImageUrl(faqType.icon);
    
    }
  }, [faqType]);
  useEffect(() => {
    setCountries(locations.countries);
  }, []);
 
  useEffect(() => {
    const modalElement = modalRef.current;
    const handleShow = () => {
      console.log("Handle show");
    };
    const handleHide = () => {
      reset();
      onHide();
    };
    modalElement.addEventListener("show.bs.modal", handleShow);
    modalElement.addEventListener("hide.bs.modal", handleHide);

    return () => {
      modalElement.removeEventListener("show.bs.modal", handleShow);
      modalElement.removeEventListener("hide.bs.modal", handleHide);
    };
  }, [onHide]);
  const handleImageChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      setImageUrl(URL.createObjectURL(files[0]));
    }
  };
 
  return (
    <div>
      <div className="modal fade" id="add-faqType" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div></div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="row">
                  
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <UnlimitInput
                            label={t("tableColumnName.typeName")}
                            id="name"
                            type="text"
                            placeholder={t("inputField.placeholder.enterTypeName")}
                            register={register}
                            rules={{
                              required: t("inputField.validation.required"),
                              pattern: {
                                value: /^[a-zA-Z\s]*$/,
                                message: t("inputField.validation.pattern"),
                              },
                            }}
                            error={errors.name}
                            errorMessage={errors.name?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 mb-3">
                      <UnlimitFileUpload
                        label={t("inputField.label.logo")}
                        id="icon"
                        register={register}
                        accept=".jpeg, .png, .jpg"
                        error={errors.icon}
                        rules={{
                          required: !faqType && t("inputField.validation.required"),
                        }}
                        errorMessage={errors.icon?.message}
                        onChange={handleImageChange}
                      />
                      {(faqType || imageUrl) && (
                        <img
                          src={
                            faqType
                              ? faqType && imageUrl
                                ? imageUrl
                                : existingImageUrl
                              : imageUrl
                          }
                          alt="Company Image"
                          className="img-fluid ms-2"
                          style={{ maxWidth: "70px", maxHeight: "70px" }}
                        />
                      )}{" "}
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-blocks m-0">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <UnlimitToggle
                            isChecked={faqType ? false : true}
                            label={t("tableColumnName.status")}
                            id="status"
                            register={register}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t("general.button.cancel")}
                      </button>
                      <UnlimitSubmitButton
                        label={
                          faqType
                            ? t("general.button.update")
                            : t("general.button.submit")
                        }
                        isLoading={isLoading}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqTypeDetail;
